import axios from "axios";
import NProgress from "nprogress";
import Vue from "vue";
const client = axios.create({
  baseURL: Vue.prototype.$apiUrl,
  withCredentials: false
});

client.interceptors.request.use(config => {
  NProgress.start();
  return config;
});

client.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.reject(error.response);
  }
);

// Payment
function UpdatePayment(payment) {
  payment.action = "payment";
  return client.put("payments.php", payment);
}

function CreatePayment(payment) {
  payment.action = "payment";
  return client.post("payments.php", payment);
}

function GetPayment(id) {
  const params = {
    id: id,
    action: "payment"
  };
  return client.get("payments.php", { params });
}

function GetPayments(filter) {
  const params = {
    dtfrom: filter.start,
    dtto: filter.end,
    code: filter.code,
    respperson: filter.respperson,
    action: "payments"
  };
  return client.get("payments.php", { params });
}

function DeletePayment(id) {
  const params = {
    id: id,
    action: "payment"
  };
  return client.delete("payments.php", { params });
}

// Installment
function UpdateInstallment(inst) {
  inst.action = "inst";
  return client.put("payments.php", inst);
}

function CreateInstallment(inst) {
  inst.action = "inst";
  return client.post("payments.php", inst);
}

function GetInstallments(id) {
  const params = {
    id: id,
    action: "insts"
  };
  return client.get("payments.php", { params });
}

function GetInstallmentsByStudent(id) {
  const params = {
    id: id,
    action: "instsbystudent"
  };
  return client.get("payments.php", { params });
}

function DeleteInstallment(id) {
  const params = {
    id: id,
    action: "inst"
  };
  return client.delete("payments.php", { params });
}

// Tran
function UpdateTran(inst) {
  inst.action = "tran";
  return client.put("payments.php", inst);
}

function CreateTran(inst) {
  inst.action = "tran";
  return client.post("payments.php", inst);
}

function GetTran(id) {
  const params = {
    id: id,
    action: "tran"
  };
  return client.get("payments.php", { params });
}

function GetTranByStudent(studentid) {
  const params = {
    studentid: studentid,
    action: "tranbystudent"
  };
  return client.get("payments.php", { params });
}

function DeleteTran(id) {
  const params = {
    id: id,
    action: "tran"
  };
  return client.delete("payments.php", { params });
}

function GetClassStudentsDebt(id) {
  const params = {
    id: id,
    action: "debt"
  };
  return client.get("payments.php", { params });
}

function GetStudentDebt(id) {
  const params = {
    id: id,
    action: "sdebt"
  };
  return client.get("payments.php", { params });
}

export {
  UpdatePayment,
  CreatePayment,
  DeletePayment,
  GetPayment,
  GetPayments,
  UpdateInstallment,
  CreateInstallment,
  DeleteInstallment,
  GetInstallments,
  UpdateTran,
  CreateTran,
  DeleteTran,
  GetTran,
  GetClassStudentsDebt,
  GetStudentDebt,
  GetInstallmentsByStudent,
  GetTranByStudent
};
